import { MappingsQueryData } from './types';

export const MAPPINGS_ENDPOINT = '/mappings';
export const DEFAULT_RESULTS: MappingsQueryData = [];
export const UNDERSCORE_SUBSCRIBED_MESSAGE_TYPE_IDS = '__subscribedMessageTypeIds';
